// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"861":"8c4d2d0834e1b248","888":"4d7983efec20e770","916":"8c4d2d0834e1b248","996":"8c4d2d0834e1b248"}[chunkId] + ".css";
};